@if(launcherInputGroup$ | async; as launcherInputGroup) {
  <zaeper-form-builder (onChange)="handleOnChange($event)" [inputElement]="launcherInputGroup" />
  <p-button [rounded]="true" [loading]="(isSaving$ | async) ?? false" (onClick)="handleSave()">Speichern</p-button>
}
